import React from 'react'
import { connect } from 'react-redux'
import { ApiProvider, Project, ResourceUsers } from '@leverege/api-redux'
import { ResourceUsersScreen } from '@leverege/api-ui-user-management'

const allowedRoles = [ 'Creator', 'Admin', 'User' ]

class UserScreen extends React.Component {

  static contextType = ApiProvider.Context

  roleFilter = ( role ) => {
    return allowedRoles.includes( role.name ) && role.projectId === 'imagine'
  }

  render() {
    const originalApi = this.context

    const actions = Project( 'imagine' )
    actions.users = () => {
      return new ResourceUsers( {
        resourceId : 'imagine',
        resourceApi : getProjectApi
      } )
    }
    
    return (
      <ResourceUsersScreen
        allowApiAccess
        selectorProps={{
          simple : false,
          roleFilter : this.roleFilter,
          inCustom : false,
          inProject : false,
          inImagine : true,
        }} 
        resourceId="imagine"
        actions={actions}
        api={{ ...originalApi, project : () => getProjectApi( null, null, { api : originalApi }, 'imagine' ) }}/>
    )
  }
}

function getProjectApi( dispatch, getState, opts, resourceId ) {
  const {
    api
  } = opts;
  const r = api.project( resourceId )
  const og = r.users.bind( r )
  r.users = ( ...args ) => {
    return {
      ...og( ...args ),
      create : ( body, opts ) => {
        if ( opts?.test ) {
          return api.users().create( body, opts )
        }
        return api.users().create( { ...body, permissions : { role : 'creator' } }, opts )
      },
      add : async ( body, opts ) => {
        if ( opts?.test ) {
          return og( ...args ).add( body, opts )
        }

        let u
        if ( !body.userId ) {
          u = await api.users().create(
            {
              ...body.user,
              permissions : { role : 'creator' }
            },
            { sendEmail : body?.sendEmail, emailOptions : body?.emailOptions }
          )
        }
        await api.project( resourceId ).user( u?.id || body?.userId ).addRoles( body.roles )
        const userRoleObj = await api.project( resourceId ).user( u?.id || body?.userId ).get()
        return userRoleObj
      },
      list : async ( opts ) => {
        return og( ...args ).list( opts )
      }
    }
  }
  // console.log( r )
  r.accounts = api.users.bind( api )
  r.account = api.user.bind( api )
  return r;
}

export default connect(
  ( state, props ) => ( {} )
)( UserScreen );
